<form [formGroup]="form">
  <div formArrayName="items" class="check-box-list">
    @for (item of items.controls; track item; let i = $index) {
      <div>
        <input type="checkbox" [formControlName]="i" [id]="'cbItem' + i" /><label [for]="'cbItem' + i">{{ options[i].label }}</label>
      </div>
    }
  </div>
</form>
